import { render, staticRenderFns } from "./CustomerObiady.vue?vue&type=template&id=905b4b66&scoped=true&"
import script from "./CustomerObiady.vue?vue&type=script&lang=js&"
export * from "./CustomerObiady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b4b66",
  null
  
)

export default component.exports